import { render, staticRenderFns } from "./SimpleVehicleViewOptionsTable.vue?vue&type=template&id=20735e79&"
import script from "./SimpleVehicleViewOptionsTable.vue?vue&type=script&lang=js&"
export * from "./SimpleVehicleViewOptionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports